// extracted by mini-css-extract-plugin
export default {"showcase":"ShowcasePage_showcase__F-kGa"};